import React, { Component } from 'react';
import { Modal, Panel, Button, Glyphicon } from 'react-bootstrap'

export class HandleDialog extends Component {
    renderHeaderIcon() {
        const { icon } = this.props;

        if (undefined === icon || null === icon || "" === icon) {
            return null;
        }

        return (
                <Glyphicon glyph={icon} />
        );
    }

    render() {
        const { show, style, title, message, argument } = this.props;

        if(!show) {
            return null;
        }

        const messageLines = [];
        if ("string" === typeof message) {
            message.split("\n").map((msg, i) => messageLines.push(<div key={`dialog-${i}`}>{msg}</div>));
        }
        else {
            messageLines.push(<div key="dialog-line">{message}</div>);
        }

        return (
            <Modal
                onHide={() => this.props.onExit(false, argument)}
                show={true}>
                <Modal.Body className="padding-0">
                    <Panel bsStyle={style} className="margin-bottom-0 border-0" >
                        <Panel.Heading>
                            <h3 className="alert-title">{this.renderHeaderIcon()}&nbsp;&nbsp;{title}</h3>
                        </Panel.Heading>

                        <Panel.Body>
                            <div>
                                <div className="padding-top-20 padding-bottom-20 font-size-12 break-word">
                                    {messageLines}
                                </div>
                                <div className="pull-right">
                                    <Button onClick={() => this.props.onExit(true, argument)}> SIM </Button>
                                    &nbsp;
                                    <Button onClick={() => this.props.onExit(false, argument)}> NÃO </Button>
                                </div>
                            </div>
                        </Panel.Body>
                    </Panel>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HandleDialog.js